var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_380_78759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.675 31.3543C37.3947 33.2512 38.8279 35.2258 40.7247 35.5531C42.6139 35.8846 44.6555 34.5114 45.0679 32.637C43.915 34.2083 44.1012 36.6055 45.4922 37.9537C46.8833 39.302 49.2959 39.4208 50.8429 38.224C52.3899 37.0272 52.8559 34.6585 51.8892 32.9771C53.5884 33.9112 55.9193 33.5249 57.2458 32.1001C58.5681 30.668 58.7698 28.3234 57.7029 26.7096C56.636 25.0957 54.4049 24.3596 52.5587 25.0188C54.4873 25.5743 56.7579 24.4438 57.4708 22.5738C58.1838 20.7038 57.2537 18.3604 55.4404 17.5217C53.6271 16.6829 51.2128 17.4426 50.2154 19.1806C52.1361 18.6856 53.3586 16.4234 52.8301 14.5192C52.3015 12.615 50.2476 11.3233 48.2685 11.5266C46.2895 11.7299 44.5707 13.3018 44.041 15.2141C44.6804 13.4062 43.8664 11.2128 42.2119 10.253C40.5575 9.29318 38.2351 9.69425 36.9757 11.1494C35.7163 12.6045 35.6489 14.9407 36.8363 16.4359C36.4261 14.3747 34.0248 13.0662 31.9784 13.5843C29.932 14.1025 28.4506 16.1391 28.3236 18.2336C28.1967 20.328 29.2804 22.3857 30.8941 23.724C32.5079 25.0622 34.5973 25.7419 36.6273 25.9727C35.8126 26.8364 35.3014 28.038 35.4702 29.2127C35.639 30.3875 36.6135 31.4432 37.7921 31.5235C38.9739 31.5921 40.1628 30.4635 37.675 31.3543Z",
    fill: "url(#paint0_radial_380_78759)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1288 13.4819C32.7437 13.4605 32.356 13.4941 31.9803 13.5894C29.9343 14.108 28.453 16.1453 28.3258 18.2403C28.1985 20.3353 29.2816 22.3934 30.8948 23.7318C32.5079 25.0701 34.5967 25.7497 36.6261 25.9802C35.8115 26.8443 35.3004 28.0462 35.4689 29.2212C35.6309 30.3506 36.5372 31.3699 37.6536 31.5185C37.4708 33.367 38.8767 35.2443 40.7211 35.5624C42.1154 35.8071 43.5928 35.1224 44.4368 33.9929C44.0866 35.3831 44.455 36.9622 45.4871 37.963C46.8775 39.3114 49.2896 39.4299 50.8363 38.2326C52.3831 37.0352 52.8493 34.6659 51.8831 32.9842C53.5818 33.9183 55.9121 33.5316 57.2385 32.1062C58.5607 30.6735 58.7627 28.3283 57.6963 26.7142C57.5386 26.4755 57.3554 26.256 57.1518 26.0574C55.7338 26.9557 53.8451 27.1508 52.3536 26.384C51.2664 25.8251 50.4687 24.8075 50.0809 23.6537C49.6133 24.7438 48.744 25.6768 47.6368 26.1242C45.4566 27.0052 42.7571 26.0296 41.5244 24.0466C40.3522 22.1609 40.519 19.6024 41.7645 17.7488C40.4483 19.4429 37.9518 20.1447 35.9603 19.3436C33.8621 18.4996 32.5692 16.0558 33.0377 13.8391C33.0631 13.7186 33.0936 13.5994 33.1288 13.4819Z",
    fill: "url(#paint1_linear_380_78759)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.87421,
    ry: 2.87416,
    transform: "matrix(0.527751 0.849399 -0.849196 0.528078 49.4741 23.5353)",
    fill: "#4FBE42"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.3461,
    ry: 3.34604,
    transform: "matrix(0.527751 0.849399 -0.849196 0.528079 53.8058 27.6609)",
    fill: "url(#paint2_radial_380_78759)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 6.09161,
    ry: 6.0915,
    transform: "matrix(0.527751 0.849399 -0.849195 0.528079 46.332 20.184)",
    fill: "url(#paint3_radial_380_78759)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5037 24.4617C47.6515 26.2078 43.9209 25.3267 42.1531 22.4814C40.7001 20.1429 41.0232 17.2023 42.7542 15.2375C42.7419 15.245 42.7295 15.2527 42.7172 15.2603C39.8603 17.0369 38.9836 20.7937 40.7591 23.6513C42.5346 26.5089 46.2899 27.3853 49.1468 25.6087C49.6658 25.2859 50.1195 24.8978 50.5037 24.4617Z",
    fill: "url(#paint4_linear_380_78759)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4789 31.1078C43.1218 30.8015 42.8049 30.436 42.5434 30.0151C41.6262 28.539 41.6226 26.7532 42.3782 25.3191L43.445 26.6074C42.7949 26.5844 42.2948 27.4293 42.6399 27.9717C42.9849 28.514 43.9685 28.4184 44.2221 27.82C44.4315 28.1152 44.6417 28.4074 44.852 28.6997C45.0622 28.992 45.2725 29.2843 45.4818 29.5794C45.3409 29.7456 45.1928 29.9096 45.0469 30.0712C45.008 30.1143 44.9692 30.1573 44.9307 30.2001C44.4464 30.5025 43.9625 30.8051 43.4789 31.1078Z",
    fill: "#35A328",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.71882,
    ry: 4.71881,
    transform: "matrix(0.527751 0.849399 -0.849195 0.528079 47.2063 27.1172)",
    fill: "url(#paint5_radial_380_78759)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.5123 27.9814C45.8877 30.1951 48.7967 30.8739 51.0099 29.4977C51.1612 29.4036 51.3054 29.3023 51.4422 29.1945C51.0661 29.9631 50.4766 30.6387 49.6966 31.1238C47.4835 32.5 44.5744 31.8212 43.199 29.6075C41.9177 27.5453 42.4195 24.8785 44.2835 23.4106C43.5926 24.8225 43.6217 26.548 44.5123 27.9814Z",
    fill: "url(#paint6_linear_380_78759)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.283 53.7371C33.2945 53.7371 30.0611 53.3428 30.0611 52.8564C30.0611 52.3699 33.2945 51.9756 37.283 51.9756C41.2715 51.9756 44.5049 52.3699 44.5049 52.8564C44.5049 53.3428 41.2715 53.7371 37.283 53.7371Z",
    fill: "url(#paint7_radial_380_78759)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7498 36.0535C30.9851 35.6674 27.9485 36.9803 27.8713 37.4437C27.1078 41.9747 27.7683 45.2956 29.4325 49.4662C29.9128 50.6847 30.5905 51.929 31.5427 52.564C31.8772 52.7871 32.2889 52.5125 32.3147 52.0577C32.4176 50.3415 31.9801 48.8483 32.126 46.4541C32.1345 46.334 32.1774 46.8145 32.126 46.7116C30.3846 43.5193 29.8614 41.8116 29.4325 38.0444C29.4153 37.8899 29.99 36.1479 29.8871 36.045C29.8785 36.0535 29.7413 36.0535 29.7498 36.0535Z",
    fill: "url(#paint8_linear_380_78759)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5016 24.8924C31.9197 27.7071 29.921 31.0624 28.6686 34.6751C27.7765 37.2753 27.2618 40.0899 27.8794 42.7673C28.497 45.4447 30.4099 47.9419 33.0605 48.6455C34.27 48.9716 35.6768 48.8601 36.5861 48.0019C37.4525 47.1781 37.6669 45.8652 37.5468 44.6724C37.4267 43.4796 37.0493 42.3297 36.9292 41.1369C36.7233 39.0774 37.3667 36.9406 38.6791 35.3359C39.9916 33.7312 41.9473 32.6757 44.1433 32.5298C44.0232 32.0235 43.9031 31.5258 43.7744 31.0195C43.2426 31.5086 42.4449 31.7489 41.7586 31.5086C41.0724 31.2769 40.5663 30.5132 40.7293 29.8009C40.8922 29.0887 41.7843 28.6167 42.4191 28.9685C41.9731 28.0847 41.527 27.2008 41.0895 26.3169C40.6177 26.9777 40.1202 27.6556 39.3825 27.9903C38.6448 28.3164 37.6154 28.1361 37.2895 27.3896C37.075 26.8919 37.238 26.3083 37.5039 25.8364C37.8385 25.2528 38.3274 24.7551 38.9365 24.4719C38.4046 24.2917 37.9243 23.9828 37.6412 23.4851C37.2723 23.1075 36.9121 22.7213 36.5432 22.3438C35.3937 23.5108 34.4587 24.8838 34.5016 24.8924Z",
    fill: "url(#paint9_radial_380_78759)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9682 20.9329C37.8653 20.8256 37.762 20.7186 37.658 20.6123C36.4036 21.8855 35.3832 23.3833 35.43 23.3927C32.6122 26.4632 30.431 30.1235 29.0642 34.0647C28.0906 36.9012 27.5289 39.9718 28.203 42.8926C28.4209 43.8369 28.7866 44.7607 29.2795 45.6045C29.8099 45.8197 30.357 45.9716 30.9163 46.0508C32.5107 46.2841 34.2424 45.8226 35.165 44.3509C36.0425 42.9395 35.9823 40.9346 35.5336 39.1791C35.3093 38.3014 35.0071 37.4531 34.705 36.6049C34.4029 35.7567 34.1008 34.9084 33.8765 34.0307C33.1036 30.9994 33.3737 27.6747 34.6138 25.004C35.3936 23.3244 36.5461 21.9157 37.9682 20.9329Z",
    fill: "url(#paint10_radial_380_78759)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M8 9.87453C8.37033 8.45965 9.31408 7.24255 10.4729 7.02956C11.6316 6.81656 12.9099 7.77503 13.1249 9.25076C13.3519 10.7721 12.5873 12.7195 13.543 13.678C14.0209 14.1496 14.7257 14.0583 15.2394 13.6932C15.7531 13.328 18.2379 9.87453 19.1936 8.90085C19.8028 8.2923 20.663 7.69896 21.2961 8.27708C22.3713 9.25076 21.0213 11.7002 21.8217 13.039C22.1562 13.6019 22.8013 13.754 23.3389 13.5867C23.8765 13.4193 26.5763 11.0003 27.4723 10.194C27.9382 9.76803 28.4638 9.32683 29.0253 9.43333C29.7421 9.55504 30.2199 10.7113 29.8974 11.5328",
    stroke: "#8B8B8B",
    strokeOpacity: 0.37,
    strokeWidth: 2.99567,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M6 24.7278C7.36256 24.5372 8.70683 22.7527 9.1092 22.3542C9.55729 21.9038 10.2614 21.8951 10.7095 22.259C11.0022 22.5015 12.0081 24.1734 12.9317 24.5199C13.3066 24.6585 13.709 24.7798 14.1022 24.7191C14.8521 24.5979 15.3367 23.9308 15.9311 23.489C16.6079 22.9866 17.7327 22.1983 18.4642 22.6661C19.4153 23.2725 19.269 25.646 21.3265 24.8317C21.9484 24.5805 22.4879 24.1994 23 23.7749",
    stroke: "#989898",
    strokeOpacity: 0.2,
    strokeWidth: 3.27651,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M3 38.1741C3.97446 37.9635 4.93583 35.9911 5.22359 35.5507C5.54405 35.0528 6.04763 35.0433 6.36809 35.4454C6.57737 35.7135 7.29677 37.5613 7.95731 37.9443C8.22545 38.0975 8.51321 38.2315 8.79442 38.1645C9.3307 38.0305 9.67732 37.2932 10.1024 36.805C10.5864 36.2496 11.3908 35.3784 11.914 35.8954C12.5942 36.5656 12.4895 39.189 13.961 38.289C14.4057 38.0113 14.7916 37.5901 15.1578 37.1209",
    stroke: "#989898",
    strokeOpacity: 0.2,
    strokeWidth: 3.27651,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4144 33.461L36.2897 16.6548L40.4057 21.0339L22.5219 37.8396L18.4144 33.461Z",
    fill: "url(#paint11_linear_380_78759)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2784 16.6639L38.9266 19.4812L21.0554 36.2743L18.4142 33.4589L36.2784 16.6639Z",
    fill: "url(#paint12_linear_380_78759)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4506 33.4552L36.3259 16.649L37.1943 17.7242L19.3105 34.5299L18.4506 33.4552Z",
    fill: "url(#paint13_linear_380_78759)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6885 14.4024L38.1386 14.9255C37.3238 15.6893 37.2835 16.968 38.047 17.7831L39.3895 19.2122C40.153 20.0274 41.4313 20.0678 42.2461 19.304L42.796 18.781C43.6108 18.0172 43.6511 16.7385 42.8876 15.9234L41.5451 14.4943C40.7816 13.6791 39.4948 13.6381 38.6885 14.4024Z",
    fill: "url(#paint14_radial_380_78759)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7774 17.422L37.9879 17.6461C38.7515 18.4613 40.0297 18.5017 40.8445 17.7379L41.3944 17.2148C42.0968 16.5565 42.2237 15.5156 41.7564 14.7187L42.8883 15.9237C43.6519 16.7388 43.6115 18.0175 42.7967 18.7813L42.2468 19.3044C41.432 20.0681 40.1537 20.0277 39.3902 19.2126L38.0477 17.7835C37.9423 17.6709 37.8522 17.5496 37.7774 17.422Z",
    fill: "url(#paint15_radial_380_78759)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9835 15.0709L34.9805 17.8847L39.0965 22.2638L42.1 19.4414L37.9835 15.0709Z",
    fill: "url(#paint16_linear_380_78759)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9835 15.0709L34.9805 17.8847L39.0965 22.2638L42.1 19.4414L37.9835 15.0709Z",
    fill: "url(#paint17_linear_380_78759)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0144 17.8525L37.6931 20.7023L40.6614 17.913L42.1003 19.4407L39.0968 22.2631L34.9808 17.884L35.0144 17.8525Z",
    fill: "url(#paint18_linear_380_78759)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1834 38.6354L22.4923 37.7693L18.3848 33.3908L17.1834 38.6354Z",
    fill: "#FFECA7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1929 38.5967L21.0637 36.2487L22.4923 37.7717L17.1835 38.6378L17.1929 38.5967Z",
    fill: "url(#paint19_linear_380_78759)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6383 38.232L17.1836 38.6324L17.739 36.2075L19.6383 38.232Z",
    fill: "#F04534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3163 37.0615C33.1582 34.7359 30.9427 31.1028 29.7847 28.7773C29.5616 28.3311 29.33 27.8591 29.3386 27.3614C29.3472 26.8637 29.6731 26.323 30.1621 26.263C30.5138 26.2201 30.8483 26.4089 31.1228 26.6234C31.8863 27.2155 32.4353 28.0393 32.9328 28.8631C34.1165 30.8368 36.1605 34.2468 36.8639 36.4436C37.087 37.1301 36.6838 37.9625 36.0061 38.2114C35.7574 38.3057 35.4657 38.3229 35.2427 38.177C34.7709 37.8681 34.7795 37.6707 34.3163 37.0615Z",
    fill: "url(#paint20_linear_380_78759)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6114 24.8422C27.7793 23.3499 28.4863 21.901 29.6171 20.7504C30.192 20.1675 30.9781 19.6256 31.8419 19.697C32.4065 19.7434 32.9147 20.0597 33.2409 20.4591C33.6503 20.9629 33.8255 21.6303 33.5954 22.2175C33.3738 22.8057 32.7072 23.2833 31.9996 23.2813C31.2834 23.2783 30.6192 22.7372 30.551 22.1164C29.5305 22.9772 28.6045 23.9178 27.6114 24.8422Z",
    fill: "url(#paint21_linear_380_78759)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8947 29.1376C35.5385 29.5045 35.0837 29.6415 34.8818 29.4409C34.6781 29.2429 34.8041 28.7874 35.1602 28.4204C35.5164 28.0535 35.9712 27.9165 36.1731 28.1171C36.3787 28.3123 36.2509 28.7706 35.8947 29.1376Z",
    fill: "url(#paint22_radial_380_78759)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8141 32.204C38.4579 32.5709 38.0032 32.7079 37.8013 32.5073C37.5975 32.3093 37.7235 31.8538 38.0797 31.4869C38.4359 31.1199 38.8906 30.9829 39.0925 31.1835C39.2981 31.3788 39.1703 31.837 38.8141 32.204Z",
    fill: "url(#paint23_radial_380_78759)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.549 30.7713C36.5488 30.795 36.5715 30.8144 36.5943 30.81C36.6363 30.8067 36.6783 30.8033 36.7195 30.7954C36.7533 30.7866 36.7818 30.7622 36.8184 30.7551C36.8842 30.7401 36.9452 30.7616 36.9602 30.8275C36.9708 30.8705 36.9493 30.9315 36.9234 30.9696C36.8967 31.0032 36.8454 31.0201 36.8024 31.0426C36.6045 31.1351 36.3922 31.0905 36.3067 30.941C36.2212 30.7915 36.2862 30.5373 36.4431 30.4289C36.4808 30.4028 36.5493 30.3896 36.5884 30.4082C36.6539 30.4407 36.6378 30.5054 36.6109 30.5627C36.5561 30.6846 36.5477 30.7028 36.549 30.7713Z",
    fill: "#188055"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2935 45.3217C34.7996 48.042 36.1978 50.5992 38.2136 52.4871C38.4538 52.7188 38.754 52.9505 39.0886 52.899C39.406 52.8475 39.629 52.53 39.6719 52.2039C39.7148 51.8864 39.6204 51.5603 39.5346 51.2514C38.6854 48.3509 37.8362 45.4504 36.987 42.5499C36.8326 42.035 36.661 41.4858 36.2235 41.1769C35.6316 40.7564 34.7395 40.9795 34.2763 41.5459C33.8131 42.1123 33.7445 42.9103 33.8989 43.6226C34.0619 44.3348 34.4307 44.9784 34.7138 45.7508C34.628 45.7679 34.5422 45.7851 34.2935 45.3217Z",
    fill: "#B9E9B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9499 42.631C29.638 42.4781 29.9342 42.4175 30.0649 42.1509C30.1956 41.8843 30.1113 41.5127 30.4231 41.6656C30.735 41.8185 30.9892 42.2014 30.8585 42.468C30.7278 42.7346 30.2617 42.7839 29.9499 42.631Z",
    fill: "url(#paint24_linear_380_78759)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8746 42.1836C30.9023 42.2831 30.9005 42.3821 30.858 42.4689C30.8029 42.5813 30.6881 42.6551 30.5504 42.6913C30.5236 42.5974 30.5241 42.5035 30.5619 42.4195C30.6149 42.3019 30.7325 42.2233 30.8746 42.1836Z",
    fill: "url(#paint25_linear_380_78759)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_380_78759",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.2748 8.95535) rotate(91.264) scale(27.7165 33.6117)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60C454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_380_78759",
    x1: 42.249,
    y1: 38.0807,
    x2: 39.9677,
    y2: 8.20277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A72A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#2F9822"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AD56F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_380_78759",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.50145 0.600571) rotate(67.4123) scale(5.80773 5.80781)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DBD3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A126"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_380_78759",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.71595 2.0591) rotate(40.8686) scale(10.9486 10.9486)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51C143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_380_78759",
    x1: 44.964,
    y1: 11.2363,
    x2: 39.4802,
    y2: 27.1223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35A328"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_380_78759",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.50721 8.83704) rotate(-110.982) scale(9.46459 9.4646)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61D154"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_380_78759",
    x1: 51.0823,
    y1: 30.2621,
    x2: 30.3945,
    y2: 26.5527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81E275"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_380_78759",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.0839 53.4329) rotate(180) scale(21.7209 21.6804)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00555556,
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_380_78759",
    x1: 32.3889,
    y1: 43.7714,
    x2: 25.3209,
    y2: 46.3642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EDB66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3752,
    stopColor: "#8BE085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9E9B6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_380_78759",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.763 45.5509) rotate(-45.2734) scale(26.512 26.5119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8EEB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384682,
    stopColor: "#ADEAA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64617,
    stopColor: "#98E392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#309A23"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_380_78759",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.3631 55.8577) rotate(-75.8432) scale(32.3429 27.6017)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#B9E9B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744913,
    stopColor: "#7CDD75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_380_78759",
    x1: 30.1265,
    y1: 16.2526,
    x2: 28.6916,
    y2: 38.2422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9B400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_380_78759",
    x1: 29.3389,
    y1: 16.2111,
    x2: 28.0001,
    y2: 36.7275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC224"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_380_78759",
    x1: 28.4386,
    y1: 16.1343,
    x2: 27.2045,
    y2: 35.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE081"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED85F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_380_78759",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3706 13.6704) rotate(72.7928) scale(6.43471 6.48844)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F04331"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_380_78759",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.3747 13.668) rotate(72.8146) scale(6.43702 6.48575)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4574B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC3423"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_380_78759",
    x1: 33.9533,
    y1: 15.9451,
    x2: 39.7888,
    y2: 22.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.348533,
    stopColor: "#FF974B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF640D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_380_78759",
    x1: 40.9208,
    y1: 18.6483,
    x2: 37.8771,
    y2: 14.9047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.348533,
    stopColor: "#FF974B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#FF9D4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817708,
    stopColor: "#FEBE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF974B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_380_78759",
    x1: 33.9536,
    y1: 15.944,
    x2: 39.7895,
    y2: 22.4208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.533493,
    stopColor: "#FF974B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E43801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_380_78759",
    x1: 22.4577,
    y1: 36.3485,
    x2: 17.409,
    y2: 38.3332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFECA7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_380_78759",
    x1: 34.3211,
    y1: 27.6329,
    x2: 35.6818,
    y2: 38.3045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9FFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADEAA8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_380_78759",
    x1: 32.8973,
    y1: 21.0713,
    x2: 23.8062,
    y2: 25.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6EDB66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3752,
    stopColor: "#8BE085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9E9B6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_380_78759",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.5281 28.7784) rotate(44.3256) scale(0.748314 0.748419)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    stopColor: "#077145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05663E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_380_78759",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4475 31.8448) rotate(44.3258) scale(0.74831 0.748417)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    stopColor: "#077145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05663E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_380_78759",
    x1: 30.8547,
    y1: 42.4759,
    x2: 30.0174,
    y2: 42.0654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DE7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACEBA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_380_78759",
    x1: 30.4737,
    y1: 42.2438,
    x2: 31.2313,
    y2: 42.6715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#72C869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACEBA7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_380_78759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.3b198c9c9f800a6c39e22d7ee2a66753.svg";
export { ForwardRef as ReactComponent };